import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Article from "@/pages/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/guide/:slug",
    element: <Article />,
  },
  {
    path: "/usfans-spreadsheet-guide",
    element: <Navigate to="/guide/usfans-spreadsheet-guide" replace />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;